/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: constants.ts (Agents Constants)
 🗓️ Created: 2025-01-05
 🧩 Description:
    Constants and default values for Agents module.

 🔧 Notes:
    - Default form state values
    - Valid option sets

 🔁 Last Updated: 2025-01-05 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import { FormState, AgentStatus, AgentType, AgentStateMode } from './types/agents.types';

export const STATUS_OPTIONS: AgentStatus[] = [
  'Available',
  'Available (On Demand)',
  'Logged Out',
  'On Break'
];

export const AGENT_TYPE_OPTIONS: AgentType[] = ['Inbound', 'Outbound', 'Callback'];
export const STATE_MODE_OPTIONS: AgentStateMode[] = ['auto', 'manual'];

export const KNOWN_SETTINGS_KEYS = new Set([
  'state_mode',
  'max_no_answer',
  'busy_delay_time',
  'reject_delay_time',
  'no_answer_delay_time',
  'contact_timeout',
  'wrap_up_time',
  'agent_type',
  'max_calls',
  'record_calls'
]);

export const DEFAULT_FORM_STATE: FormState = {
  // General
  agentName: '',
  extension: '',
  enabled: true,
  initialStatus: 'Logged Out',
  stateMode: 'auto',
  agentType: 'Inbound',
  recordCalls: false,
  maxConcurrentCalls: '1',
  
  // Behavior
  maxNoAnswer: '3',
  busyDelayTime: '90',
  rejectDelayTime: '90',
  noAnswerDelayTime: '30',
  contactTimeout: '20',
  wrapUpTime: '10',
  
  // Advanced
  rejectMultipleCalls: false,
  skipAgentWhileBusy: false,
  agentCooldown: '0',
  ignoreBusyAfterTimeout: false,
  
  createdAt: null,
  updatedAt: null
};

